import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { IFooterItem, IFooterItemLink } from './interfaces';
import { baseTheme } from '../../theme';

// TODO: Connect this Data from State Store once we establish
import {
  footerBarData,
} from './data';

const getFooterData = () => ({
  ...footerBarData,
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      paddingTop: theme.spacing(10),
      paddingBottom: theme.spacing(4),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      backgroundColor: theme.palette.text.disabled,
      textAlign: 'center',
    },
    footerItemContainer: {
      paddingBottom: theme.spacing(10),
    },
    footerHeading: {
      color: theme.palette.primary.main,
      fontSize: '1.8em',
      paddingBottom: theme.spacing(4),
      fontWeight: 'normal',
    },
    footerItemDesktop: {
      width: '18%',
    },
    footerLinkContainer: {
      paddingBottom: theme.spacing(2),
      fontSize: '1em',
    },
    copyright: {
      fontSize: '0.85em',
      paddingTop: theme.spacing(3),
    },
  }),
);

export default function FooterBar(): JSX.Element {
  const classes = useStyles(baseTheme);
  const footerData = getFooterData();

  const footerItemHeading = (heading: string) => (
    <div className={classes.footerHeading}>
      {heading}
    </div>
  );

  const footerItemLink = (link: IFooterItemLink) => {
    return (
      <div className={classes.footerLinkContainer} key={link.title}>
        <Link component={RouterLink} to={link.linkURL} color="textPrimary">{link.title}</Link>
      </div>
    );
  };

  const createDesktopFooterItem = (item: IFooterItem) => (
    <Grid item className={classes.footerItemDesktop} key={item.heading}>
      {footerItemHeading(item.heading)}
      {item.links.map(footerItemLink)}
    </Grid>
  );
  const createMobileFooterItem = (item: IFooterItem) => (
    <Grid container justify="center" key={item.heading}>
        <Grid container justify="center" alignItems="center">
          {footerItemHeading(item.heading)}
        </Grid>
        <Grid item>
          {item.links.map(footerItemLink)}
        </Grid>
    </Grid>
  );

  return (
    <Grid container direction="column" className={classes.root} id={'footer'}>
        {window.innerWidth >= 600 &&
        <Grid item className={classes.footerItemContainer}>
            <Grid container justify="center" spacing={0}>
                {footerData.footerItems.map(createDesktopFooterItem)}
            </Grid>
        </Grid>}
        {window.innerWidth < 600 &&
            <Grid container direction="column" spacing={0}>
                {footerData.footerItems.map(createMobileFooterItem)}
            </Grid>}
      <Grid item>
        <Typography color="textPrimary" className={classes.copyright}>
          <span dangerouslySetInnerHTML={{ __html: footerData.copyrightText }}>
          </span>
        </Typography>
      </Grid>
    </Grid>
  );
}
